import { Center, Spinner } from '@chakra-ui/react';
import { FullScreenLoader } from '@ui/components/FullScreenLoader';

export type QueryLoadingProps = {
  title?: string;
  fullScreen?: boolean;
};

export function QueryLoading({ title, fullScreen }: QueryLoadingProps) {
  if (fullScreen) {
    return <FullScreenLoader loadingText={title} />;
  }

  return (
    <Center padding={10} width="100%">
      <Spinner label={title} />
    </Center>
  );
}
